import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import { Typography } from '@mui/material';

/**
 * Hook personalizado para mostrar mensajes usando el sistema de mensajes de Fuse
 * @returns {Function} Función para mostrar mensajes
 */
export const useMessage = () => {
  const dispatch = useDispatch();

  const showMessageUtil = (msg, color = 'info') => {
    dispatch(
      showMessage({
        message: (
          <>
            <Typography>{msg}</Typography>
          </>
        ),
        autoHideDuration: 6000,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        variant: color, // success, error, info, warning, null
      })
    );
  };

  return showMessageUtil;
};

/**
 * Función utilitaria para mostrar mensajes (para usar en componentes funcionales)
 * @param {Function} dispatch - Función dispatch de Redux
 * @param {string} msg - Mensaje a mostrar
 * @param {string} color - Color/variante del mensaje (success, error, info, warning, null)
 */
export const showMessageUtil = (dispatch, msg, color = 'info') => {
  dispatch(
    showMessage({
      message: (
        <>
          <Typography>{msg}</Typography>
        </>
      ),
      autoHideDuration: 6000,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
      variant: color,
    })
  );
};
